import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-radius: 5px;
    margin-bottom: 24px;
    cursor: pointer;
  `,
  content: css`
    padding: 16px 16px 32px 16px;
  `,

  listItem: css`
    &.MuiListItemButton-root {
      padding: 9px 0px;
    }
    & > .MuiListItemIcon-root {
      min-width: auto;
    }
  `,
  checklist: css`
    &.MuiCheckbox-root {
      color: ${colors.prussian};
      padding: 0px;
      margin-right: 8px;
    }
  `,
  column: css`
    display: flex;
    flex-direction: column;
  `,
  formLabel: css`
    padding-bottom: 15px;

    &:hover {
      background-color: #f7f7f7;
    }
  `,
  formLabelSelected: css`
    background-color: ${colors.platinum};
    border-left: 3px solid ${colors.jungle};
    padding: 8px 0 15px 13px;

    &:hover {
      background-color: #f7f7f7;
    }
  `,
  popper: css`
    max-width: 262px;
    margin-top: 6px !important;
    overflow: visible;
  `,
  option: css`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    cursor: pointer;

    &:hover {
      background-color: #f7f7f7 !important;
    }

    &.Mui-focusVisible:not(.Mui-selected),
    &:focus-visible:not(.Mui-selected) {
      background-color: transparent !important;
      outline: 2px solid ${colors.focusOutlineColor};
      outline-offset: -2px;
    }

    &.Mui-selected {
      background-color: ${colors.platinum} !important;
      border-left: 3px solid ${colors.jungle};
      padding-left: 13px;
    }

    &.Mui-selected:hover {
      background-color: #f7f7f7 !important;
    }

    &.Mui-selected.Mui-focusVisible,
    &.Mui-selected:focus-visible {
      background-color: ${colors.platinum} !important;
      outline: 2px solid ${colors.focusOutlineColor};
      outline-offset: -2px;
    }
  `,
  popoverTitle: css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 20px 0px 20px 0px;
    border-bottom: 1px solid ${colors.silver};
  `,
  closeButton: css`
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 22px;
    color: ${colors.prussian};
  `,
  dialogTitle: css`
    border-radius: 4px;

    &:focus-visible {
      outline: 2px solid ${colors.focusOutlineColor};
      outline-offset: 2px;
    }
  `,
};

export default styles;
